class Money {
  constructor({ amount, currency }, locale = 'en') {
    this.amount = amount
    this.currency = currency
    this.locale = locale
  }

  add = ({ amount, currency }) => {
    if (currency !== this.currency) {
      throw new Error('Currency mismatch')
    }

    this.amount = this.amount + amount

    return this
  }

  subtract = ({ amount, currency }) => {
    if (currency !== this.currency) {
      throw new Error('Currency mismatch')
    }

    this.amount = this.amount - amount

    return this
  }

  multiply = multiplier => {
    this.amount = this.amount * multiplier

    return this
  }

  percentage = (percentage, rounding = 'round') => {
    this.amount = Math[rounding]((this.amount * percentage) / 100)

    return this
  }

  format = () => {
    return global.Intl.NumberFormat(this.locale, {
      style: 'currency',
      currency: this.currency,
    }).format(this.amount / 100)
  }
}

export const formatMoney = (money, locale) => {
  if (!money) return null

  return new Money(money, locale).format()
}

export const getCurrencySymbol = (currency, locale) => {
  if (!currency) return null

  /**
   * Because `NumberFormat().formatToParts()` is only supported on recent versions of some
   * browsers we have this fallback object.
   */
  const fallbackSymbols = {
    EUR: '€',
    GBP: '£',
    USD: '$',
    CAD: 'CA$',
    AUD: 'A$',
    NZD: 'NZ$',
    BRL: 'R$',
  }

  try {
    return global.Intl.NumberFormat(locale, { style: 'currency', currency })
      .formatToParts()
      .find(({ type }) => type === 'currency').value
  } catch {
    const symbol = fallbackSymbols[currency]

    if (symbol) return symbol
  }

  return currency
}

export default Money
